// import { batch } from "react-redux";
import * as API from "../../api";
import * as ActionTypes from "../action-types";

import { message } from "antd";

// Constants and config
import { TIME } from "../../util";

// Redux actions
import { 
  setLoadingDashboardAll, 
  unsetLoadingDashboardAll,
  setLoadingDashboardDaily,
  unsetLoadingDashboardDaily,
  setLoadingDashboardMonthly,
  unsetLoadingDashboardMonthly
} from "./style"

const { lastDay, currentTime } = TIME;

export const get_all_dashboard_request =
  () => (dispatch) => {

   dispatch(setLoadingDashboardAll());

    API.getAllDashboard()
      .then((info) => {
        const { status, msg, dashboard } = info;

        if (status === 200) {
          dispatch(get_all_dashboard_success(dashboard));
          message.success("Successfully get dashboard data");
        } else {
          message.warning(msg);
        }
      }).finally(() => {
        dispatch(unsetLoadingDashboardAll());
      });
  };

const get_all_dashboard_success = (dashboard) => {
  return {
    type: ActionTypes.DASHBOARD_GET_ALL,
    dashboard,
  };
};


export const get_dashboard_timeframe_daily_thru_90days_request = () => (dispatch) => {
  dispatch(get_dashboard_timeframe_daily_all_request(lastDay(90), currentTime()));
};

export const get_dashboard_timeframe_daily_all_request =
  (startTime, endTime) => (dispatch) => {

    dispatch(setLoadingDashboardDaily());

  API.getDashboardTimeFrameDaily({
    startTime,
    endTime,
  })
    .then((info) => {
      const { status, summaries, payrolls, topAppliedCompanies, topAppliedEmployees, topAppliedEmployeesByDays, total_active_companies, total_all_employee_activate, total_employees, msg } = info;

      const dashboard = {
        summaries,
        payrolls,
        topAppliedCompanies,
        topAppliedEmployees,
        topAppliedEmployeesByDays,
        total_active_companies,
        total_all_employee_activate,
        total_employees
      };
      
      if (status === 200) {
        dispatch(get_dashboard_timeframe_daily_all_success(dashboard));
        message.success("Successfully get dashboard daily data");
      } else {
        message.warning(msg);
      }
    }).finally(() => {
        dispatch(unsetLoadingDashboardDaily());
      });
};

const get_dashboard_timeframe_daily_all_success = (dashboard) => {
  return {
    type: ActionTypes.DASHBOARD_TIMEFRAME_DAILY_GET_ALL,
    dashboard,
  };
};



export const get_dashboard_timeframe_monthly_thru_90days_request = () => (dispatch) => {
  dispatch(get_dashboard_timeframe_monthly_all_request(lastDay(90), currentTime()));
};

export const get_dashboard_timeframe_monthly_all_request =
  (startTime, endTime) => (dispatch) => {

    dispatch(setLoadingDashboardMonthly());
    
  API.getDashboardTimeFrameMonthly({
    startTime,
    endTime,
  })
    .then((info) => {
      const { status, summaries, msg } = info;

      if (status === 200) {
        dispatch(get_dashboard_timeframe_monthly_all_success(summaries));
        message.success("Successfully get dashboard monthly data");
      } else {
        message.warning(msg);
      }
    }).finally(() => {
      dispatch(unsetLoadingDashboardMonthly());
    });
};

const get_dashboard_timeframe_monthly_all_success = (summaries) => {
  return {
    type: ActionTypes.DASHBOARD_TIMEFRAME_MONTHLY_GET_ALL,
    summaries,
  };
};